import { Image } from '@/types/image.type';

export type EngagementModelColor = 'blue' | 'green';

export interface EngagementModel {
  id: string;
  titleKey: string;
  descriptionKey: string;
  image: Image;
  featuresKey: string;
  color: EngagementModelColor;
}

export const engagementModels: EngagementModel[] = [
  {
    id: 'project-based',
    titleKey: 'projectBased.title',
    descriptionKey: 'projectBased.description',
    image: {
      src: '/images/engagements/engagement-1.webp',
      alt: 'Project based',
    },
    featuresKey: 'projectBased.features',
    color: 'blue',
  },
  {
    id: 'team-extension',
    titleKey: 'teamExtension.title',
    descriptionKey: 'teamExtension.description',
    image: {
      src: '/images/engagements/engagement-2.webp',
      alt: 'Team extension',
    },
    featuresKey: 'teamExtension.features',
    color: 'green',
  },
];
